import React from 'react';
import { Megaphone } from 'lucide-react';
import { useCollection } from '../hooks/useCollection';

const FlashNews = () => {
  const { documents: news, error } = useCollection('flashNews', ['isActive', '==', true]);

  const newsItems = news?.map(item => `${item.text} / ${item.textHindi}`).join(' • ');

  return (
    <div className="bg-yellow-100 border-b-2 border-yellow-200 flex items-center overflow-hidden shadow-sm">
      <div className="w-12 h-full flex items-center justify-center bg-yellow-400 py-2">
        <Megaphone size={24} className="text-white" />
      </div>
      <div className="flex-1 relative h-full">
        {error && <p className="text-red-500 px-4 py-2">{error}</p>}
        {news && (
          <div className="flex items-center">
            <div className="animate-marquee whitespace-nowrap px-4 py-2">
                <span className="font-medium text-yellow-900 text-sm">Latest News:</span>
                <span className="ml-4 text-sm text-yellow-800">{newsItems}</span>
                {/* Duplicate for seamless scroll */}
                <span className="ml-12 font-medium text-yellow-900 text-sm">Latest News:</span>
                <span className="ml-4 text-sm text-yellow-800">{newsItems}</span>
            </div>
          </div>
        )}
        {!news && !error && (
            <div className="px-4 py-2 text-sm text-yellow-800">Loading news...</div>
        )}
      </div>
    </div>
  );
};

export default FlashNews;
